import { SVGProps } from "react"

const Ethereum = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" fill="none" {...props}>
    <path d="M253 335.122L255.886 338L388 259.987L255.886 41L253 50.7983V335.122Z" fill="#343434" />
    <path d="M256 338V41L124 259.986L256 338Z" fill="#8C8C8C" />
    <path d="M254 465.281L255.628 470L388 285L255.629 362.563L254.001 364.532L254 465.281Z" fill="#3C3C3B" />
    <path d="M124 285L256 470V362.562L124 285Z" fill="#8C8C8C" />
    <path d="M256 200V338L388 259.988L256 200Z" fill="#141414" />
    <path d="M256 200L124 259.988L256 338V200Z" fill="#393939" />
</svg>

export default Ethereum;